(function () {
  var cfg = window.SL_CONFIG || {};

  var DEFAULT_ZOOM                = cfg.defaultZoom;
  var SEARCH_ZOOM                 = cfg.searchZoom;
  var SEARCH_COUNTRIES            = (cfg.searchCountries || '').split(',').map(function (c) { return c.trim().toUpperCase(); }).filter(Boolean);
  var US_CENTER                   = { lat: 39.5, lng: -98.35 };
  var SEATTLE_CENTER              = { lat: 47.6062, lng: -122.3321 };
  var GEO_METHOD                  = cfg.geoMethod;
  var SHOW_DISTANCE               = cfg.showDistance;
  var SHOW_BG_PINS                = cfg.showBgPins;
  var CLUSTER_PINS                = cfg.clusterPins;
  var COLOR_INSTALLER             = cfg.colorInstaller;
  var COLOR_RETAILER              = cfg.colorRetailer;
  var COLOR_PROFESSIONAL_SERVICES = cfg.colorProfessionalServices;

  var map, geocoder, infoWindow;
  var CLUSTER_NUM_ZOOM    = 7;

  var markers             = [];
  var bgMarkers           = [];
  var clusterMarkers      = [];
  var clusterer           = null;
  var activeClusterMarker = null;
  var lastClusterFilter   = null;
  var filteredStores      = [];
  var viewportStores      = [];
  var searchCenter        = null;
  var activeIdx           = null;
  var programmaticPan     = false;
  var suppressViewport    = false;

  var stores = [];
  var storesReady = (function () {
    var collected = [];
    function fetchPage(page) {
      return fetch(window.location.pathname + '?view=dealer-locator-json&page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          collected = collected.concat(data.stores);
          if (page < data.pagination.totalPages) return fetchPage(page + 1);
          stores = collected;
        });
    }
    return fetchPage(1).catch(function (err) {
      console.error('[SL] Failed to load dealer data:', err);
    });
  })();

  /* ── Utilities ─────────────────────────── */

  //Calculation for distance between 2 points on map
  function haversineMiles(lat1, lng1, lat2, lng2) {
    var R    = 3958.8;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a    = Math.sin(dLat / 2) * Math.sin(dLat / 2)
             + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180)
             * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getCheckedTypes() {
    var vals = [];
    document.querySelectorAll('.sl-type:checked').forEach(function (cb) {
      vals.push(cb.value);
    });
    return vals;
  }

  function storeMatchesTypes(store, types) {
    var t = store.dealer_type;
    return (t === 'retail'                && types.includes('retail'))
        || (t === 'installer'             && types.includes('installer'))
        || (t === 'professional_services' && types.includes('professional_services'));
  }

  function typeColor(store) {
    var t = store.dealer_type;
    if (t === 'installer')             return COLOR_INSTALLER;
    if (t === 'professional_services') return COLOR_PROFESSIONAL_SERVICES;
    return COLOR_RETAILER;
  }

  function mapIsVisible() {
    if (!map) return false;
    var el = document.getElementById('sl-map');
    return el && el.offsetWidth > 0;
  }

  /* ── Filter + render pipeline ──────────── */

  //Filters and sorts all stores, then renders the list and syncs markers
  function run() {
    var types      = getCheckedTypes();
    var pool       = (map && viewportStores.length > 0) ? viewportStores : stores;
    var sortCenter = map ? { lat: map.getCenter().lat(), lng: map.getCenter().lng() } : searchCenter;

    var results = pool.map(function (s) {
      var dist = sortCenter && s.latitude != null && s.longitude != null
        ? haversineMiles(sortCenter.lat, sortCenter.lng, s.latitude, s.longitude)
        : null;
      return Object.assign({}, s, { _dist: dist });
    });

    results = results.filter(function (s) { return storeMatchesTypes(s, types); });

    if (sortCenter) {
      results.sort(function (a, b) { return a._dist - b._dist; });
    } else {
      results.sort(function (a, b) { return a.dealer_name.localeCompare(b.dealer_name); });
    }

    results = results.slice(0, 25);

    filteredStores = results;
    renderList(results);
    syncMarkers(results);
  }

  //Same as run() but scoped to what's currently visible on the map
  function runViewport() {
    if (!map) return;
    if (programmaticPan) { programmaticPan = false; return; }
    if (suppressViewport) return;
    var mapEl = document.getElementById('sl-map');
    if (!mapEl || mapEl.offsetWidth === 0) return;
    var bounds = map.getBounds();
    if (!bounds) { run(); return; }

    var types  = getCheckedTypes();
    var center = map.getCenter();

    viewportStores = stores.filter(function (s) {
      return s.latitude != null && s.longitude != null && bounds.contains({ lat: s.latitude, lng: s.longitude });
    });

    var results = viewportStores
      .filter(function (s) { return storeMatchesTypes(s, types); })
      .map(function (s) {
        return Object.assign({}, s, {
          _dist: haversineMiles(center.lat(), center.lng(), s.latitude, s.longitude),
        });
      });

    results.sort(function (a, b) { return a._dist - b._dist; });
    results = results.slice(0, 25);

    filteredStores = results;
    renderList(results);
    syncMarkers(results, viewportStores.filter(function (s) { return storeMatchesTypes(s, types); }));
  }

  /* ── List rendering ────────────────────── */

  function buildBadges(store) {
    var base = 'inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium';
    var html = '';
    var t = store.dealer_type;
    if (t === 'retail')                html += '<span class="' + base + '" style="background:' + COLOR_RETAILER + ';color:white">Retailer</span>';
    if (t === 'installer')             html += '<span class="' + base + '" style="background:' + COLOR_INSTALLER + ';color:white">Installer</span>';
    if (t === 'professional_services') html += '<span class="' + base + '" style="background:' + COLOR_PROFESSIONAL_SERVICES + ';color:white">Professional Services</span>';
    return html;
  }

  //Renders the sidebar store list and wires card click events
  function renderList(list) {
    var countEl = document.getElementById('sl-count');
    var listEl  = document.getElementById('sl-list');

    countEl.textContent = list.length + ' location' + (list.length !== 1 ? 's' : '') + ' found';

    if (list.length === 0) {
      listEl.innerHTML = '<div class="px-4 py-10 text-center text-zinc-400 text-sm leading-relaxed">No locations found in this area.<br>Try expanding your distance or changing your search.</div>';
      return;
    }

    listEl.innerHTML = list.map(function (store, i) {
      var num      = i + 1;
      var badges   = buildBadges(store);
      var mapsHref = 'https://www.google.com/maps/dir/?api=1&destination='
                   + encodeURIComponent(store.address + ', ' + store.city + ', ' + store.region + ' ' + store.zip);
      var distLabel = (SHOW_DISTANCE && store._dist !== null)
        ? ' <span style="font-weight:400;color:#9ca3af;">· ' + Math.round(store._dist) + ' mi</span>'
        : '';

      var numBadge = '<span style="flex-shrink:0;min-width:20px;height:20px;border-radius:9999px;background:' + typeColor(store) + ';color:white;font-size:12px;font-weight:700;display:inline-flex;align-items:center;justify-content:center;padding:0 3px;">' + num + '</span>';

      return '<div class="sl-card flex flex-col gap-1.5 cursor-pointer rounded-lg bg-white px-4 py-4 shadow-sm transition-shadow duration-150 hover:shadow-md" data-sl-idx="' + i + '">'
        + '<div class="flex items-center gap-2">'
        + numBadge
        + '<strong class="text-base font-semibold text-zinc-900 leading-snug">' + esc(store.dealer_name) + distLabel + '</strong>'
        + '</div>'
        + (badges ? '<div class="flex flex-wrap gap-1.5">' + badges + '</div>' : '')
        + '<a href="' + mapsHref + '" target="_blank" rel="noopener" class="inline-block w-fit text-sm text-zinc-500 hover:text-zinc-700 hover:underline">'
        +   esc(store.address) + '<br>'
        +   esc(store.city) + ', ' + esc(store.region) + ' ' + esc(store.zip)
        + '</a>'
        + (store.website ? '<div class="text-sm"><a href="' + esc(store.website) + '" target="_blank" rel="noopener" class="text-zinc-500 hover:text-zinc-900 underline">Visit Website &rarr;</a></div>' : '')
        + '</div>';
    }).join('');

    listEl.querySelectorAll('.sl-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        activateIdx(parseInt(card.dataset.slIdx, 10));
      });
    });
  }

  /* ── Map markers ───────────────────────── */

  //Builds an SVG map pin as a data URI; scale controls size, number shows inside the pin
  function pinIcon(color, scale, number) {
    var w        = Math.round(27 * scale);
    var h        = Math.round(43 * scale);
    var num      = number != null ? String(number) : '';
    var fontSize = num.length <= 1 ? 11 : num.length === 2 ? 8 : 6;
    var textEl   = num
      ? '<text x="13.5" y="13.5" text-anchor="middle" dominant-baseline="central" fill="#333" font-size="' + fontSize + '" font-family="sans-serif" font-weight="700">' + num + '</text>'
      : '';
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + w + '" height="' + h + '" viewBox="0 0 27 43">'
      + '<path d="M13.5 0C6.04 0 0 6.04 0 13.5c0 10.12 13.5 29.5 13.5 29.5S27 23.62 27 13.5C27 6.04 20.96 0 13.5 0z" fill="' + color + '"/>'
      + '<circle cx="13.5" cy="13.5" r="9" fill="white" fill-opacity="0.95"/>'
      + textEl
      + '</svg>';
    return {
      url:        'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: new google.maps.Size(w, h),
      anchor:     new google.maps.Point(w / 2, h),
    };
  }

  function dimMarkerIcon() {
    return pinIcon('#d1d5db', 0.7, null);
  }

  function markerIcon(color, isActive, number) {
    return pinIcon(color, isActive ? 1.5 : 1.0, number);
  }

  //Clears and redraws map markers to match the current filtered list; handles both cluster and standard modes
  function syncMarkers(list, bgList) {
    if (!map) return;

    if (CLUSTER_PINS) {
      if (clusterer) {
        var types    = getCheckedTypes();
        var typesKey = types.slice().sort().join(',');
        if (typesKey !== lastClusterFilter) {
          lastClusterFilter = typesKey;
          var visible = clusterMarkers.filter(function (m) {
            return storeMatchesTypes(m._store, types);
          });
          clusterer.clearMarkers();
          clusterer.addMarkers(visible);
        }
      }
      refreshClusterPinIcons();
      return;
    }

    markers.forEach(function (m) { m.setMap(null); });
    bgMarkers.forEach(function (m) { m.setMap(null); });
    markers   = [];
    bgMarkers = [];
    activeIdx = null;
    if (infoWindow) infoWindow.close();

    var filteredIds = {};
    list.forEach(function (s) { filteredIds[s.seller_id] = true; });

    if (SHOW_BG_PINS) {
      (bgList || stores).forEach(function (store) {
        if (filteredIds[store.seller_id] || store.latitude == null || store.longitude == null) return;
        bgMarkers.push(new google.maps.Marker({
          position: { lat: store.latitude, lng: store.longitude },
          map:      map,
          title:    store.dealer_name,
          icon:     dimMarkerIcon(),
        }));
      });
    }

    var regularCount = 0;
    list.forEach(function (store, i) {
      if (store.latitude == null || store.longitude == null) return;
      var num    = ++regularCount;
      var color  = typeColor(store);
      var marker = new google.maps.Marker({
        position: { lat: store.latitude, lng: store.longitude },
        map:      map,
        title:    store.dealer_name,
        icon:     markerIcon(color, false, num),
        zIndex:   i,
      });

      marker._color  = color;
      marker._num    = num;
      marker._zIndex = i;

      marker.addListener('click', function () {
        activateIdx(i);
        scrollToCard(i);
      });

      markers.push(marker);
    });
  }

  //Initializes clustering on map and overrides default values
  function initClusterer() {
    var types   = getCheckedTypes();
    var initNum = map.getZoom() <= CLUSTER_NUM_ZOOM ? 1 : null;
    clusterMarkers = stores.reduce(function (acc, store) {
      if (store.latitude == null || store.longitude == null) return acc;
      var color  = typeColor(store);
      var marker = new google.maps.Marker({
        position: { lat: store.latitude, lng: store.longitude },
        title:    store.dealer_name,
        icon:     pinIcon(color, 1.0, initNum),
      });
      marker._store = store;
      marker._color = color;
      marker.addListener('click', function () {
        var idx = filteredStores.findIndex(function (s) { return s.seller_id === store.seller_id; });
        if (idx !== -1) {
          activateIdx(idx);
          scrollToCard(idx);
        } else {
          if (activeClusterMarker && activeClusterMarker !== marker) {
            activeClusterMarker.setZIndex(undefined);
          }
          activeClusterMarker = marker;
          marker.setIcon(pinIcon(color, 1.5, storeRankInList(store)));
          marker.setZIndex(999);
          refreshClusterPinIcons();
          programmaticPan = true;
          map.panTo(marker.getPosition());
          openInfoWindowForStore(store, marker);
        }
      });
      acc.push(marker);
      return acc;
    }, []);

    var initialVisible = clusterMarkers.filter(function (m) {
      return storeMatchesTypes(m._store, types);
    });

    clusterer = new markerClusterer.MarkerClusterer({
      map:      map,
      markers:  initialVisible,
      renderer: {
        render: function (cluster) {
          var count = cluster.count;
          var color = count >= 10 ? '#E3371E' : '#3D5A80';
          var size  = count < 10 ? 36 : count < 100 ? 44 : 52;
          var half  = size / 2;
          var fs    = Math.round(size * 0.3);
          var svg   = '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '">'
            + '<circle cx="' + half + '" cy="' + half + '" r="' + half + '" fill="' + color + '"/>'
            + '<text x="50%" y="50%" dominant-baseline="central" text-anchor="middle" fill="white"'
            + ' font-size="' + fs + '" font-family="sans-serif" font-weight="700">' + count + 'x</text>'
            + '</svg>';
          return new google.maps.Marker({
            position: cluster.position,
            icon: {
              url:        'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
              scaledSize: new google.maps.Size(size, size),
              anchor:     new google.maps.Point(half, half),
            },
            zIndex: 1000,
          });
        },
      },
    });
  }

  //Map pin info card structure
  function openInfoWindowForStore(store, marker) {
    if (!infoWindow) infoWindow = new google.maps.InfoWindow();
    var mapsUrl = 'https://www.google.com/maps/search/?api=1&query='
      + encodeURIComponent(store.address + ', ' + store.city + ', ' + store.region + ' ' + store.zip);
    infoWindow.setContent(
      '<div style="display:flex; align-items:flex-start; justify-content:space-between; gap:12px; margin-bottom:4px">'
      +   '<div style="font-size:15px;font-weight:600">' + esc(store.dealer_name) + '</div>'
      +   '<button onclick="window._slIW&&window._slIW.close();window._slDeactivate&&window._slDeactivate()" style="flex-shrink:0;background:none;border:none;cursor:pointer;font-size:18px;line-height:1;color:#9ca3af;padding:0;margin-top:-1px">&times;</button>'
      + '</div>'
      + '<a href="' + mapsUrl + '" target="_blank" rel="noopener" style="font-size:13px;color:#1d4ed8;text-decoration:underline;">'
      +   esc(store.address) + '<br>'
      +   esc(store.city) + ', ' + esc(store.region) + ' ' + esc(store.zip)
      + '</a>'
      + ((SHOW_DISTANCE && store._dist != null) ? '<div style="font-size:13px;color:#6b7280;margin-top:2px">' + Math.round(store._dist) + ' miles away</div>' : '')
    );
    if (marker.getMap()) {
      infoWindow.open(map, marker);
    } else {
      infoWindow.setPosition(marker.getPosition());
      infoWindow.open(map);
    }
  }

  //Used to set the ranked number on each pin based on distance
  function storeRankInList(store) {
    for (var i = 0; i < filteredStores.length; i++) {
      if (filteredStores[i].seller_id === store.seller_id) return i + 1;
    }
    return null;
  }

  //Highlights the selected store card and enlarges its map marker; pans the map to it; switches to map view on mobile
  function activateIdx(idx) {
    showMapView();
    var listEl = document.getElementById('sl-list');
    listEl.querySelectorAll('.sl-card').forEach(function (c) {
      c.classList.remove('sl-active');
    });

    var card = listEl.querySelector('[data-sl-idx="' + idx + '"]');
    if (card) card.classList.add('sl-active');

    var store = filteredStores[idx];

    if (CLUSTER_PINS) {
      if (activeClusterMarker) activeClusterMarker.setZIndex(undefined);
      activeClusterMarker = null;
      activeIdx = idx;

      if (map && store) {
        var cm = clusterMarkers.find(function (m) { return m._store.seller_id === store.seller_id; });
        if (cm) {
          activeClusterMarker = cm;
          cm.setIcon(pinIcon(cm._color, 1.5, storeRankInList(store)));
          cm.setZIndex(999);
          refreshClusterPinIcons();
          programmaticPan = true;
          map.panTo(cm.getPosition());
          openInfoWindowForStore(store, cm);
        }
      }
      return;
    }

    if (activeIdx !== null && markers[activeIdx]) {
      var pm = markers[activeIdx];
      pm.setIcon(markerIcon(pm._color, false, pm._num));
      pm.setZIndex(pm._zIndex);
    }

    activeIdx = idx;

    if (map && markers[idx]) {
      var am = markers[idx];
      am.setIcon(markerIcon(am._color, true, am._num));
      am.setZIndex(999);
      programmaticPan = true;
      map.panTo(markers[idx].getPosition());
      openInfoWindowForStore(store, am);
    }
  }

  function scrollToCard(idx) {
    var card = document.querySelector('#sl-list [data-sl-idx="' + idx + '"]');
    if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  //Clears active state from cards, markers, and info window
  function deactivate() {
    document.querySelectorAll('.sl-card').forEach(function (c) { c.classList.remove('sl-active'); });
    if (infoWindow) infoWindow.close();
    if (CLUSTER_PINS) {
      if (activeClusterMarker) {
        activeClusterMarker.setZIndex(undefined);
        activeClusterMarker = null;
        refreshClusterPinIcons();
      }
    } else {
      if (activeIdx !== null && markers[activeIdx]) {
        var pm = markers[activeIdx];
        pm.setIcon(markerIcon(pm._color, false, pm._num));
        pm.setZIndex(pm._zIndex);
      }
      activeIdx = null;
    }
  }

  //Updates pin numbers on cluster markers when zoom level or filtered list changes
  function refreshClusterPinIcons() {
    if (!map || !clusterMarkers.length) return;
    var zoom = map.getZoom();

    var rankMap = {};
    if (zoom > CLUSTER_NUM_ZOOM) {
      var regularCount = 0;
      filteredStores.forEach(function (s) {
        rankMap[s.seller_id] = ++regularCount;
      });
    }

    clusterMarkers.forEach(function (m) {
      if (m === activeClusterMarker) return;
      var num = zoom <= CLUSTER_NUM_ZOOM ? 1 : (rankMap[m._store.seller_id] || null);
      m.setIcon(pinIcon(m._color, 1.0, num));
    });
  }

  /* ── Mobile map-view helper ─────────────── */

  //Collapses the sidebar and expands the map on mobile
  function showMapView() {
    if (window.innerWidth >= 1080) return;
    var sl = document.getElementById('store-locator');
    var sidebar = document.getElementById('sl-sidebar');
    if (!sl || sl.classList.contains('sl-map-view')) return;
    sl.classList.add('sl-map-view');
    if (map) setTimeout(function () { google.maps.event.trigger(map, 'resize'); }, 300);
  }

  
  //Search method
  function doSearch() {
    var query = (document.getElementById('sl-input').value || '').trim();

    if (!query) {
      searchCenter = null;
      if (map) { map.setCenter(US_CENTER); map.setZoom(DEFAULT_ZOOM); }
      else run();
      return;
    }

    if (!geocoder) {
      run();
      return;
    }

    var geocodeReq = { address: query };
    if (SEARCH_COUNTRIES.length) geocodeReq.componentRestrictions = { country: SEARCH_COUNTRIES.length === 1 ? SEARCH_COUNTRIES[0] : SEARCH_COUNTRIES };
    geocoder.geocode(
      geocodeReq,
      function (results, status) {
        if (status === 'OK' && results[0]) {
          var loc      = results[0].geometry.location;
          searchCenter = { lat: loc.lat(), lng: loc.lng() };
          map.setCenter(searchCenter);
          map.setZoom(SEARCH_ZOOM);
          showMapView();
        } else {
          searchCenter = null;
          if (map) runViewport(); else run();
        }
      }
    );
  }


  //Browser geolocation — only fires silently if permission is already granted; does not prompt on load
  function getUserLocation() {
    return new Promise(function (resolve) {
      if (!navigator.geolocation) { resolve(null); return; }
      navigator.geolocation.getCurrentPosition(
        function (pos) { resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }); },
        function ()    { resolve(null); },
        { maximumAge: 300000, enableHighAccuracy: false }
      );
    });
  }

  //IP geolocation via API. Free tier, 1000 calls/day. Result cached in localStorage for 1 hour.
  function getBoundsFromIp() {
    var TTL = 60 * 60 * 1000;
    return new Promise(function (resolve) {
      try {
        var stored = window.localStorage && window.localStorage.getItem('sl_location');
        if (stored) {
          var cached = JSON.parse(stored);
          if (!isNaN(cached.lat) && !isNaN(cached.lng) && (Date.now() - cached.ts) < TTL) {
            resolve({ lat: cached.lat, lng: cached.lng });
            return;
          }
        }
      } catch (e) {}

      fetch('https://api.ipgeolocation.io/ipgeo?apiKey=32d41415db244f538742b6d08d941740')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.latitude || !data.longitude) { resolve(null); return; }
          var loc = { lat: parseFloat(data.latitude), lng: parseFloat(data.longitude), ts: Date.now() };
          try { window.localStorage && window.localStorage.setItem('sl_location', JSON.stringify(loc)); } catch (e) {}
          resolve({ lat: loc.lat, lng: loc.lng });
        })
        .catch(function () { resolve(null); });
    });
  }

  
  //Overrides google autocomplete to increase wait before doing API call
  //Otherwise, API call on every key press
  function initAutocomplete(inputEl, acService) {
    var dropdownEl  = document.getElementById('sl-suggestions');
    var predictions = [];
    var acActive    = -1;
    var debounceTimer;

    function show(results) {
      predictions = results || [];
      acActive    = -1;
      if (!predictions.length) { hide(); return; }
      var rect = inputEl.getBoundingClientRect();
      dropdownEl.style.top   = (rect.bottom + 4) + 'px';
      dropdownEl.style.left  = rect.left + 'px';
      dropdownEl.style.width = rect.width + 'px';
      dropdownEl.innerHTML = '';
      predictions.forEach(function (p, i) {
        var li = document.createElement('li');
        li.textContent = p.description;
        li.addEventListener('mousedown', function (e) { e.preventDefault(); select(i); });
        dropdownEl.appendChild(li);
      });
      dropdownEl.style.display = 'block';
    }

    function hide() {
      dropdownEl.style.display = 'none';
      predictions = [];
      acActive    = -1;
    }

    function setActive(idx) {
      dropdownEl.querySelectorAll('li').forEach(function (li) { li.classList.remove('sl-ac-active'); });
      acActive = idx;
      var items = dropdownEl.querySelectorAll('li');
      if (idx >= 0 && items[idx]) items[idx].classList.add('sl-ac-active');
    }

    function select(idx) {
      var p = predictions[idx];
      if (!p) return;
      inputEl.value = p.description;
      hide();
      geocoder.geocode({ placeId: p.place_id }, function (results, status) {
        if (status !== 'OK' || !results[0]) return;
        var loc = results[0].geometry.location;
        searchCenter = { lat: loc.lat(), lng: loc.lng() };
        map.setCenter(searchCenter);
        map.setZoom(SEARCH_ZOOM);
        showMapView();
      });
    }

    inputEl.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var query = inputEl.value.trim();
      if (query.length < 2) { hide(); return; }
      debounceTimer = setTimeout(function () {
        var acReq = { input: query, types: ['(cities)'] };
        if (SEARCH_COUNTRIES.length) acReq.componentRestrictions = { country: SEARCH_COUNTRIES.length === 1 ? SEARCH_COUNTRIES[0] : SEARCH_COUNTRIES };
        acService.getPlacePredictions(
          acReq,
          function (results, status) {
            if (status !== google.maps.places.PlacesServiceStatus.OK) { hide(); return; }
            show(results);
          }
        );
      }, 1000);
    });

    inputEl.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        if (!predictions.length) return;
        e.preventDefault();
        setActive(Math.min(acActive + 1, predictions.length - 1));
      } else if (e.key === 'ArrowUp') {
        if (!predictions.length) return;
        e.preventDefault();
        setActive(Math.max(acActive - 1, 0));
      } else if (e.key === 'Enter') {
        if (acActive >= 0) { e.preventDefault(); select(acActive); }
        else { hide(); doSearch(); }
      } else if (e.key === 'Escape') {
        hide();
      }
    });

    document.addEventListener('click', function (e) {
      if (!dropdownEl.contains(e.target) && e.target !== inputEl) hide();
    });
  }

  //Google Maps API callback. Called by Google Maps API on load; waits for store data, 
  // then builds the map, wires events, and geolocates the user 
  window.initSL = async function () {
    await storesReady;

    var mapEl = document.getElementById('sl-map');
    if (!mapEl) return;

    var initialCenter = GEO_METHOD === 'seattle' ? SEATTLE_CENTER : US_CENTER;
    var initialZoom   = GEO_METHOD === 'seattle' ? SEARCH_ZOOM   : DEFAULT_ZOOM;

    map = new google.maps.Map(mapEl, {
      center:            initialCenter,
      zoom:              initialZoom,
      minZoom:           3,
      restriction: {
        latLngBounds: { north: 85, south: -85, west: -180, east: 180 },
        strictBounds: false,
      },
      mapTypeControl:    false,
      streetViewControl: false,
      fullscreenControl: false,
      gestureHandling:   'greedy',
    });

    geocoder             = new google.maps.Geocoder();
    infoWindow           = new google.maps.InfoWindow();
    window._slIW         = infoWindow;
    window._slDeactivate = deactivate;

    if (CLUSTER_PINS) {
      initClusterer();
      map.addListener('zoom_changed', refreshClusterPinIcons);
    }

    var inputEl   = document.getElementById('sl-input');
    var acService = new google.maps.places.AutocompleteService();
    initAutocomplete(inputEl, acService);

    map.addListener('idle', runViewport);
    map.addListener('dragstart', deactivate);

    if (navigator.permissions) {
      navigator.permissions.query({ name: 'geolocation' }).then(function (status) {
        if (status.state === 'granted') {
          getUserLocation().then(function (bounds) {
            if (!bounds || searchCenter) return;
            searchCenter = bounds;
            map.setCenter(bounds);
            map.setZoom(SEARCH_ZOOM);
          });
        }
      }).catch(function () {});
    }

    if (GEO_METHOD === 'ip') {
      getBoundsFromIp().then(function (bounds) {
        if (searchCenter) return;
        map.setCenter(bounds || SEATTLE_CENTER);
        map.setZoom(SEARCH_ZOOM);
      }).catch(function () {
        if (!searchCenter) { map.setCenter(SEATTLE_CENTER); map.setZoom(SEARCH_ZOOM); }
      });
    }
  };

  // Self-fire if the Maps API called the stub before this script finished loading
  if (window._slInitPending) {
    delete window._slInitPending;
    window.initSL();
  }

  //Wires up all UI events listeners on page load
  //And triggers initial render
  document.addEventListener('DOMContentLoaded', function () {
    document.getElementById('sl-search-btn').addEventListener('click', doSearch);
    document.getElementById('sl-input').addEventListener('input', deactivate);
    document.getElementById('sl-locate-btn').addEventListener('click', function () {
      getUserLocation().then(function (bounds) {
        if (!bounds) return;
        searchCenter = bounds;
        if (map) {
          map.setCenter(bounds);
          map.setZoom(SEARCH_ZOOM);
          showMapView();
        }
      });
    });
    document.querySelectorAll('.sl-type').forEach(function (cb) {
      cb.addEventListener('change', function () {
        if (mapIsVisible()) runViewport(); else run();
      });
    });

    var sidebarEl      = document.getElementById('sl-sidebar');
    var showMapBtn     = document.getElementById('sl-show-map');
    var showListBtn    = document.getElementById('sl-show-list');
    var storeLocatorEl = document.getElementById('store-locator');

    if (window.innerWidth < 1080) {
      storeLocatorEl.classList.add('sl-map-view');
    }

    if (showMapBtn) {
      showMapBtn.addEventListener('click', function () {
        storeLocatorEl.classList.add('sl-map-view');
        if (map) setTimeout(function () { google.maps.event.trigger(map, 'resize'); }, 300);
      });
    }

    if (showListBtn) {
      showListBtn.addEventListener('click', function () {
        suppressViewport = true;
        storeLocatorEl.classList.remove('sl-map-view');
        renderList(filteredStores);
        if (activeIdx !== null) {
          var activeCard = document.querySelector('#sl-list [data-sl-idx="' + activeIdx + '"]');
          if (activeCard) {
            activeCard.classList.add('sl-active');
            activeCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
        setTimeout(function () { suppressViewport = false; }, 350);
      });
    }

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1080) {
        storeLocatorEl.classList.remove('sl-map-view');
      }
    });

    document.getElementById('sl-count').textContent = 'Loading locations…';
    storesReady.then(function () { run(); });
  });

})();
